import { linkToCreateAssignmentJourney } from "features/teachers/features/assignment-journey/links";

export const SOURCE_PARAM = "source";

export function linkToCreateClassAssignment(classId?: string, source?: string) {
  const params = new URLSearchParams();

  if (source) {
    params.append(SOURCE_PARAM, source);
  }

  const searchParams = params.toString();

  return `${linkToCreateAssignmentJourney(classId)}${
    searchParams ? `?${searchParams}` : ""
  }`;
}
